import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import JisPrepareTemplate from '../../components/core/preparetemplate';
import PdfViewer from '../../components/controls/pdfviewer';
import { s } from 'framer-motion/client';
import JisTabButton from '../../components/controls/jisTabButton';
import JisAlert from '../../components/jisalert';
import DeadlineBadge from '../../components/controls/deadlinebadge';
import * as Services from '../../services';
import JisPrepareTemplatePlain from '../../components/core/preparetemplate_plain';

function ExecutionSherrif() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);

    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);

    const [selectedParty, setSelectedParty] =useState(null);
    const [selectedService, setSelectedService] = useState('substituted'); //true/false
    const [caseParties, setCaseParties] = useState([]);
    const [template, setTemplate] = useState(null); 
    
    const [doc, setDoc] =useState(null)
    const [docline, setDocline] = useState(null);
    const [uplinetype, setUplinetype] = useState('attest');
    const [servedon, setServedOn] = useState(null);
    const [sFile, setSFile] =useState(null);
   
    const [previewPath, setPreviewPath] = useState(false);  
   
    
    const [claimants, setClaimants] = useState('');
    const [defendants, setDefendants] = useState('');
    const [autoFill, setAutoFill] = useState([]); //this is to hold the auto fill items
    const [tab, setTab] = useState('pending');
    const [otherAlert, setOtherAlert]=useState({open:false})

    const [warrant, setWarrant] = useState(null);
    const [warrants, setWarrants]= useState([]);
    const [doclines, setDoclines]=useState([]);
    const [isItems, setIsItems] = useState(false);
    const [isReport, setIsReport] = useState(false);
    const [collectedItems, setCollectedItems] = useState([]);
const [selectedWarrant, setSelectedWarrant] = useState(null);
 const [removingIndex, setRemovingIndex] = useState(null);
const [comData, setComData]=useState(null);
const [option, setOption] = useState(null);

    useEffect(() => {
      if(search!=null){
         if(pageIndex>=0){
           onSearch(search);
         }else{
            setPageIndex(0);
          }
      }
      
        onLoadTemplate();
      
          
    }, [pageIndex,pageSize,tab]);


       useEffect(() => {
      
        if( active!=null){
          //load the parties to the case
          onLoadParties(active.case?.caseId);
          onLoadWarrants(active.case?.caseId, active.id)
          
      
        }            
    }, [active]);

    const IsDefendant=(ptid)=>{
        const v = Constants.getItemById(frequentData.partyTypes,ptid).isLead;
        var m=v??false
        return !m;
    }



  useEffect(() => {
    if(active!=null && selectedParty!=null){
      console.log('in here befor template call')
      let fill=[{holder:'[DEFENDANT]',value:`${selectedParty.firstName} ${selectedParty.lastName??''}`},
        {holder:'[CLAIMANTS]',value:claimants},{holder:'[DEFENDANTS]', value:defendants}
      ]
    
      setAutoFill(fill);
       
           setSFile(null);  
        setIsPreview(false); 
    }         
    }, [selectedParty]);  

     useEffect(() => {
    if(active!=null && selectedWarrant!=null){
      console.log('in here befor template call')
       onLoadSelectedWarrant(active.id, selectedWarrant?.id)
    }         
    }, [selectedWarrant]);

   

  useEffect(() => {
    if(template!=null && servedon!=null  ){
      onSaveSelect();
    }         
    }, [template,servedon,uplinetype]);  



  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/execution-sheriff/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoadParties= async(caseid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/loadparties/${caseid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setCaseParties(data.parties);
              let claim=''; let defe='';
              data.parties.forEach(element => {
                if(IsDefendant(element.partyTypeId)){
                  
                  defe=defe+`${element.firstName} ${element.lastName??''},`
                  console.log(`in defendant loop ${defe}`)
                }else{
                  
                  claim=claim+`${element.firstName} ${element.lastName??''},`
                  console.log(`in claimant loop ${claim}`)
                }
              });
              setDefendants(defe);
              setClaimants(claim);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
        const onLoadSelectedWarrant= async(writid,warrantlineid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-warrantline-details/${writid}/${warrantlineid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
            setCollectedItems(data.collected);
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onLoadTemplate= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/load-special-template/warrant-execution-report`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setTemplate(data.temp);
              
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }    
    const onLoadWarrants = async(caseid, writid)=>{
            //for account registration
        try {
          
            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-signed-warrants/${caseid}/${writid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
             setWarrant(data.warrant);
             setWarrants(data.warrants);
             setDoclines(data.doclines);

            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
  }

    const onContinue=(item,ind)=>{
        //navigate(`/case-details/${caseid}`)
        const division=Constants.getItemById(frequentData?.divisions,item.case.divisionId)?.title
        var _item={...item, 
          division,
       caseType: item.case?.caseFilingId==1?'litigation':'adr',type:'document' }
        setActive(_item);
        console.log(`on continue ${division}`)
        console.log(_item);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }

    const onCloseEntries=()=>{
      setActive(null);
      setIsItems(false)
      setIndex(-1);
      setWarrant(null);
        setWarrants(null);
        setDoclines(null);
 
    }
    const onCollectItems=(item,ind)=>{
      setIndex(ind);
      setActive(item);
      setIsItems(true)
    }
    const onSheriffReport=(item,ind)=>{
        //navigate(`/case-details/${caseid}`)
      
        setActive(item);
        setIndex(ind);
        setIsReport(true);
    }
   const onSelectWarrant=(opt)=>{
    setSelectedWarrant(opt);
   }

 const onSaveSelect=async()=>{

        
              
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/save-service-sherif-substituted/select`, {
                method: 'POST',
              //  body:JSON.stringify(select) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
          
            if(data.code==0){
            //update the field
               
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 


 const handleUploadChange =async (e) => {
 
        const files = e.target.files;
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       setSFile(a);
      
    };
const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }

const onUploadFiles2= async(caseid,partyid)=>{
        const uploadurl=`${Constants.apiUrl}/filing/upload-service-sheriff-document/${caseid}/${partyid}`
        var upline={
               
                uplineType: "non-attest",
                base64: sFile.base64,
                base64Ext: sFile.base64Ext,
                templateId:0,
                templatetitle: "",
                filename:sFile.filename,
             
                }

      //  setFlowError('');

            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(upline),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                  
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

const onChangePrepare=(holdervalues,html,isLegal)=>{
     
  //  setComData({html,holdervalues });

  }
  const onInstumentAppended=(e)=>{
    //after saving of instrument, this is what you get
      if(e.code==0){
              //saved already   
          }
  }

const onPrepareDone=(e)=>{
  //this is coming from from Prepare Document
  console.log('in service sherrif');
 
  //load the attached parties that are defendant, check total service created for them,
  //  then go ahead and close the window and set the the servicestatus to awaitingcfo
onUpdateStatus();
   /* var defendants=caseParties?.filter((k)=> IsDefendant(k.partyTypeId) ).length;
   if(defendants==services.length || defendants==1){
    
   } */
    
}
const onUpdateStatus=async()=>{
           
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/service-sheriff-substituted-update/${active?.caseId}`, {
                method: 'POST',
               // body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            
            if(data.code==0){
              
            
              
            } else if(data.code==-10){
                setIsExpired(true);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
           
            // onMove();
            }
       } 




const onVerifyStay=async()=>{ 
        setLoading(true);
          const verified = await Services.onVerifyStayOfExecution(active.case?.caseId);
          console.log('verification result motion'+verified)
          setActive({...active,verified_motion:verified});
          setLoading(false);
        }

const onVerifyAppeal=async()=>{
        setLoading(true);
          const verified = await Services.onVerifyAppeal(active.case?.caseId);
          console.log('verification result appeal'+verified)
          setActive({...active,verified_appeal:verified});
          setLoading(false);
        }

  const onChangeCollected = (index, key, value) => {
  setCollectedItems(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveCollected = async (index) => {
    if(collectedItems.length==1){
        return;
    }

    /* const h=claims[index];
        if(h && h.id>0){
            await onRemoveClaim_Server(h.id);
        } */
     setRemovingIndex(index);
  setTimeout(() => {
    setCollectedItems(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onAddCollected = () => {
  setCollectedItems(prev => [...prev, { id:0}]);
};

const onSaveExecution =(e)=>{
  e.preventDefault();
  setErr('');


  if(warrant.verifieda==null){
               setErr('Please Check that its not Appeal online');
               return;
             }
             if(warrant.verified==false){
               setErr('Its confirmed it has Motion on it. You cant continue');
               return;
             }
             if(option.manualVerifya!=true){
               setErr('Please check to confirm you have also confirm manually that its not on Appeal');
               return;
             }

     if (warrant.verifiedm == null) {
      setErr("Please Check that its not on Stay on Execution online");
      return;
    }
    if (warrant.verifiedm == false) {
      setErr("Its confirmed it has Motion on it. You cant continue");
      return;
    }
    if (option.manualVerifym != true) {
      setErr(
        "Please check to confirm you have also checked manually that its not on Stay on Execution",
      );
      return;
    }        
   const approveurl=`${Constants.apiUrl}/filing/save-warrant-execution/${active.id}`
          console.log('in Save Prepare')
          if(uplinetype!="template" && sFile==null && warrant.IsFinalized){
                 setErr('Please select the report');
                 return;
               }
  

           var approve={...option,
            writId:active.id,uplinetype,
            warrantId: warrant.id,
            WarrantlineId: selectedWarrant?.id,
            doc: sFile?.base64??null,
            docuplineId: docline?.id,
            base64Ext: sFile?.base64Ext??null,
            uplinetype:uplinetype,
            filename:sFile?.filename??null,
            templateJson:comData?.holdervalues?btoa(JSON.stringify(comData.holdervalues)):null ,
            html:comData?.html ? Constants.b64encode(comData.html):null,
            templateId:template!=null?template.id:null,
            templateTitle:template!=null?template.title:null,
            isPaid:warrant?.isPaid==null?false:warrant?.isPaid,
            collecteds: collectedItems,
            isFinalized:warrant?.isFinalized,
           };
              
              console.log('data to be sent');
              console.log(approve);  
  
  
        //  setFlowError('');
  
              // Sending the FormData using fetch
              setLoading(true);
              fetch(approveurl, {
              method: 'POST',
              body: JSON.stringify(approve),
              headers: {
                  'Content-Type': 'application/json, text/plain',
                  Authorization: `Bearer ${token}`,
                  },
              })
              .then(response => response.json())
              .then(data => {
                  setLoading(false);
                  if(data.code==0){
                    setIsItems(false);
                    if(warrant.isFinalized==true){
                      const ft=cases.filter((_, i) => i !== index)
                      setCases(ft);
                    }
                  
                    setOtherAlert({open:true, title:'Execution Report', subtitle:'Execution report is submitted', onOk:onOkUpload})
                  } else if(data.code==-10){
                        setIsExpired(true);
                    }else{
                      setErr(data.status);
                    }
              })
              .catch(error => {
                  console.error('Error:', error);
                  setLoading(false);
          });
}
const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}
const onOkUpload=()=>{
  setOtherAlert({open:false});

}
  return (
    <div>
     
      <CaseSearch onSearch={onSearch} frequentData={frequentData} />

      <div className='tab_body'>
<div className='tab_section'>
     
        </div>
        <div className='tab_view'>
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Execution Sherrif </span><span className='total'>{count}</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
   <th>SLA</th>
      <th>Details</th>
     { <th>Action</th>} 
     
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => {

      return (
      <tr key={index}>
            <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt?.case?.caseCategoryId)?.colour}`}}>{opt?.case?.caseNumber}</td>
      <td >{opt.case?.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt?.case?.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt?.case?.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt?.case?.createdOn).format('DD MMM, YYYY')}</td>
      <td>{Constants.getItemById(frequentData?.casestatuses,opt?.caseStatusId)?.description}</td>
      <td><DeadlineBadge dateString={opt?.slaExpire}/> </td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
     <td><JisButton variant='plain' onClick={()=>onCollectItems(opt,index)}>Warrant Execution</JisButton></td>
     
      
    </tr>
    )})} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>}
        </div>
      </div>

<BackLoader open={loading} />
{otherAlert.open && <JisAlert {...otherAlert} />}
  {openCase && active!=null && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
    <div>
      <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
    </div>
    </JisDialogForm> }

   {isItems && active!=null && <JisDialogForm title="Entered Collected Items" onClose={onCloseEntries}>
    <div>
<form onSubmit={onSaveExecution}> 
      <div>
          <JisCheckbox label="Check If Debt Paid at Scene of Execution" value={warrant?.isPaid} onChange={(e) => setWarrant({...warrant,isPaid:e})}
                />
              
        </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
          {warrants.map((opt) => (
              <div
                key={opt.id}
                className={`selected ${
                  opt.id == selectedWarrant?.id ? "active" : ""
                }`}
                onClick={() => onSelectWarrant(opt)}
                style={{ maxWidth: "40%" }}
              >
                {opt.location} - {opt.warrantType}
              </div>
            ))}
        </div>
        <div>Active Warrant: {selectedWarrant?.location}</div>
        <div>Item Collected</div>

        {  <div className='view'>
       
            {collectedItems.map((collected, index) => (
            <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                <div style={{ flex: 1, display:'flex' }}>
                
                <div  className="input-group">
                        <label>  Item Title <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Lexus 2025' required={true}  value={collected.itemTitle}
                    onChange={(e) => onChangeCollected(index, 'itemTitle', e.target.value)}   />
                        </div>
                    </div>
<div  className="input-group">
                        <label>  Item Description <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Item description' required={true}  value={collected.itemDesc}
                    onChange={(e) => onChangeCollected(index, 'itemDesc', e.target.value)}   />
                        </div>
                    </div>
<div  className="input-group">
                        <label>  Item Quantity <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Item quantity' required={true}  value={collected.itemQty}
                    onChange={(e) => onChangeCollected(index, 'itemQty', e.target.value)} type="number"  />
                        </div>
                    </div>
                  <div  className="input-group">
                        <label>  Item Type <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Money or Goods or Properties' required={true}  value={collected.itemType}
                    onChange={(e) => onChangeCollected(index, 'itemType', e.target.value)}   />
                        </div>
                    </div>
                  <JisCheckbox label="Check If Item is perishable" 
                  value={collected.isPerishable} 
                  onChange={(e) => onChangeCollected(index, 'isPerishable', e)} />  

                </div>
                <div  onClick={() => onRemoveCollected(index)} className='delete'>
                <DynamicIcon iname="trash-2"/> Delete
                </div>
            </div>
        ))}
       {selectedWarrant!=null && <div style={{textAlign:'right'}}>
           <JisButton icon="add" onClick={onAddCollected} variant='outline'>Add Item Collected</JisButton>
        </div>}
           
<JisCheckbox label="Check If you have completed the execution and you want to file report" value={warrant?.isFinalized} onChange={(e) => setWarrant({...warrant,isFinalized:e})}
                /> 
                    
       
       
       
        </div>}
{warrant?.isFinalized==true && <div>
  <div style={{display:'flex'}}>
             
              
            <div style={{display:'flex', maxWidth:450}}> 
                <span style={{padding:8}}>Type Of Document </span> 
                <div className={`selected ${uplinetype=='template'?'active':''}`} onClick={()=>setUplinetype('template')}>Template</div>
                <div className={`selected ${uplinetype=='attest'?'active':''}`} onClick={()=>setUplinetype('attest') }>Upload Document</div>
              </div>
            </div>
{ uplinetype!=null && uplinetype!='template' && 
           <div style={{display:'flex'}}>
               <div className="btn-upload">
                <input
                  type="file"
                  accept="application/pdf"
                  id={`file-upload-${index}`}
                  onChange={(e) => handleUploadChange(e,index)}
                />
                <label
                  htmlFor={`file-upload-${index}`}
                  title={sFile?.filename}
                >
                  {sFile?.path == null
                    ? 'Choose File'
                    : Constants.ReduceString(
                       sFile?.filename,
                        30
                      )}
                </label>
               {/*  {line.sFile?.path!=null && <JisButton onClick={()=> onPreview(line.sFile)}>Preview</JisButton>} */}
              </div> 
            </div>}

            <div className='view-doc'>
              { template!=null && uplinetype=='template' &&
              <JisPrepareTemplatePlain templatedoc={{...doc,upline:docline,template:template}} docInfo={active.case} 
              isLegal={true} onInstumentAppended={onInstumentAppended}  doctype="execution-report" autoFill={autoFill}
              onChange={(holdervalues,html,isLegal)=>onChangePrepare(holdervalues,html,isLegal)}
               />}


            </div>


  </div>}
              <div className='flowbuttongroup'>
                {warrant.verifiedm == null && (
                  <JisButton variant="outline" onClick={onVerifyStay}>
                    Click to verify Online 'Stay of Execution' motion
                  </JisButton>
                )}
  
                {warrant.verifiedm == false && (
                  <p className="error" style={{ display: "flex", gap: 5 }}>
                    <div style={{ flex: 1 }}> Motion- Stay on Execution</div>
                  </p>
                )}
                {warrant.verifiedm == true && (
                  <p className="success-box">Confirmed. No Stay of Execution</p>
                )}
               {warrant.verifieda == null && (
                  <JisButton variant="outline" onClick={onVerifyAppeal}>
                    Click to verify Online Appeal not filed
                  </JisButton>
                )}
  
                {warrant.verifieda == false && (
                  <p className="error" style={{ display: "flex", gap: 5 }}>
                    <div style={{ flex: 1 }}>  Appeal on the case</div>
                  </p>
                )}
                {warrant.verifieda == true && (
                  <p className="success-box">Confirmed. Not on Appeal</p>
                )}  
              </div>
              <div>

              </div>
              <JisCheckbox
                  value={option.manualVerifym}
                  label="Please confirm you have manually checked, non has filled Motion 'Stay of Execution' manually "
                  onChange={(e) => setOption({ ...option, manualVerifym: e })}
                />
                <JisCheckbox value={option.manualVerifya} 
                label="Please confirm you have manually checked, 'Appeal not filed' manually " 
             onChange={(e)=>setOption({...option,manualVerifya:e})} />

        <div  className="input-group">
            <label>Comment <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="group" />
                <textarea placeholder=' Comment' name='comment' required={true}  value={option?.comment}
        onChange={onOptionChange}  />
            </div>
        </div> 
  <div className='flowbuttongroup'>
                        
                        <JisButton type='submit' loading={loading}>Save Execution</JisButton>
                    </div> 
       {err!='' && <div className='error'>{err}</div>}             
</form>
    </div>
    </JisDialogForm> } 

 
    </div>
  );
}

export default ExecutionSherrif;